module.exports = __webpack_public_path__ + "static/img/5.e36d053.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/cha/5.png
// module id = p6BB
// module chunks = 1